import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'

@Injectable({
  providedIn: 'root',
})
export class OrderReturnService {
  constructor(private http: HttpClient) {
  }

  getOrderReturnList(body: any) {
    return this.http.post(`${ApiEndPoint.GetOrderReturnListApi}`, body)
  }

  getOrderReturn(id: number) {
    return this.http.get(`${ApiEndPoint.GetOrderReturnDetailsApi}?id=${id}`)
  }

  acceptOrderReturnRequest(body: any) {
    return this.http.post(ApiEndPoint.AcceptOrderReturnRequestApi, body)
  }

  rejectOrderReturnRequest(body: any) {
    return this.http.post(ApiEndPoint.RejectOrderReturnRequestApi, body)
  }
}
